module.exports = __webpack_public_path__ + "0f2f5ed77d6c94db915f76bcc080d454.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customer-card-2.png
// module id = 1308
// module chunks = 61